<template>
  <!------------------------------------------>
  <!-- EXECUTE JOBS -------------------------->
  <!------------------------------------------>
  <v-card class="custom_card" elevation="0">
    <v-card-title>
      <v-row no-gutters class="my-4">
        <v-col cols="12" class="text_color d-flex justify-center mt-2 mb-4">
          Ejecutar Jobs
        </v-col>
        <v-col cols="12" class="d-flex justify-center mb-2">
          <span class="body-2 text_color">
            En esta sección podrás reiniciar las tablas que se encuentran dentro
            de la base de datos seleccionada basado en los jobs que elijas.
          </span>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-2">
          <p class="caption blue--text text--accent-4">
            El procesamiento de los jobs se realizará en segundo plano, por lo
            que podrás seguir utilizando la plataforma mientras se ejecutan
          </p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text class="mt-4">
        <v-row
          no-gutters
          class="d-flex justify-center align-center"
          style="gap: 48px"
        >
          <v-col cols="12" md="5">
            <v-autocomplete
              v-model="database"
              :items="databases"
              :rules="rules.database"
              class="rounded-lg"
              label="Base de datos"
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="5">
            <v-autocomplete
              v-if="database"
              v-model="files"
              :items="filePathsOptions"
              :rules="rules.files"
              class="rounded-lg"
              label="Transformaciones"
              outlined
              multiple
              chips
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end align-end px-6 mb-2">
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="#2661FF"
          class="rounded-lg"
          @click="executeETL"
        >
          <span class="white--text">
            Ejecutar
          </span>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { etlsService } from '../../services/etls.service'

export default {
  name: 'ExecuteJobs',
  data () {
    return {
      valid: false,
      loading: false,
      database: null,
      databases: ['analytics', 'staging'],
      files: [],
      filesPaths: {
        analytics: [
          'analyticsParallelExecJob_bulk.kjb',
          'SubscriptionDatamartAnalyticsJob.kjb',
          'SubscriptionByMonthDatamartAnalyticsJob.kjb',
          'ChargesTransactionsDatamartAnalyticsJob.kjb'
        ],
        staging: [
          'staging_main_job_bulk.kjb',
          'ETL_sms/ln_main_parallel_exec_job_bulk.kjb',
          'ETL_email/Em_main_parallel_exec_job_bulk.kjb',
          'ETL_whatsapp/wh_main_parallel_exec_job_bulk.kjb',
          'ETL_widget/widget_main_parallel_exec_job_bulk.kjb',
          'ETL_staging_main/staging_main_parallel_exec_job_bulk.kjb'
        ]
      },
      rules: {
        database: [v => !!v || 'El campo base de dato es requerido'],
        files: [v => !!v.length || 'El campo job es requerido']
      }
    }
  },
  computed: {
    filePathsOptions () {
      return this.filesPaths[this.database]
    }
  },
  watch: {
    database () {
      this.files = []
    }
  },
  methods: {
    async executeETL () {
      const { database, files } = this

      this.loading = true

      try {
        const validation = this.$refs.form.validate()

        if (!validation) return

        await etlsService.executeJob(database, files)

        Vue.noty.success('Jobs ejecutados correctamente')
      } catch (error) {
        Vue.noty.error('Ocurrió un error al ejecutar los jobs')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
